import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const {
		content,
		level = 2,
		enableSubHeading,
		subHeadingContent,
		subHeadingTag = 'span',
		subHeadingPosition = 'above',
		blockId,
	} = attributes;

	const blockProps = useBlockProps.save( {
		className: `alpha-heading-blocks alpha-heading-block-${ blockId }`,
	} );

	const SubHeading =
		enableSubHeading && subHeadingContent ? (
			<RichText.Content
				tagName={ subHeadingTag }
				value={ subHeadingContent }
				className="alpha-subheading"
			/>
		) : null;

	return (
		<div { ...blockProps }>
			
			{ subHeadingPosition === 'above' && SubHeading }
			<RichText.Content
				tagName={ `h${ level }` }
				value={ content }
				className="alpha-heading"
			/>
			{ subHeadingPosition === 'below' && SubHeading }
		</div>
	);
}
